import React, { useState, useContext, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import Loader from "App/common/ui/Loader";
import Tooltip from "App/common/ui/Tooltip";
import {
  epocToDate,
  forbidExtraProps,
  decodeHandler,
  decryptData
} from "utils";
import { LayoutContext } from "App/common/hoc/Layout";

import {
  fetchVIRTRecoveryPointsStart,
  createVMTaskStart,
  resetSliderConfigs
} from "store/actions";

import { ReactComponent as NetworkSource } from "assets/images/app_svg/virtualization_network_source.svg";
import { ReactComponent as NetworkModel } from "assets/images/app_svg/virtualization_network_model.svg";
import { ReactComponent as StorageController } from "assets/images/app_svg/virtualization_storage_controller.svg";
import { ReactComponent as BootMenu } from "assets/images/app_svg/virtualization_bootmenu.svg";
import { ReactComponent as VideoGraphics } from "assets/images/app_svg/virtualization_video_graphics.svg";

function AddVirtualMachine(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const [searchInputField, setSearchInputField] = useState("");
  const [originalMachinesList, setOriginalMachinesList] = useState(
    Object.values(props.clients)
      .filter(val => val.isConfigured && val.lastBackupTime > 0)
      .sort((a, b) => a.name.localeCompare(b.name))
  );
  const [searchMachinesList, setSearchMachinesList] = useState(
    Object.values(props.clients)
      .filter(val => val.isConfigured && val.lastBackupTime > 0)
      .sort((a, b) => a.name.localeCompare(b.name))
  );
  const [dropDowns, setDropDowns] = useState({
    machinesList: false,
    recoveryPoints: false
  });
  const [ramMemoryList] = useState([1, 2, 4, 6, 8, 16]);
  const [availableRam] = useState(calculateAvailableRam());
  const [enableBuildVMButton, setBuildVMButton] = useState(false);

  const [vmDetails, setVMDetails] = useState({
    vm_name:
      lState.slidingPopup.params?.vm_name &&
      props.vmsList.filter(
        vm => vm.client_uuid === lState.slidingPopup.params?.clientUUID
      ).length === 0
        ? lState.slidingPopup.params?.vm_name
        : "",
    username: decryptData(localStorage.getItem("mirrorId")),
    client_uuid:
      lState.slidingPopup.params?.clientUUID &&
      props.vmsList.filter(
        vm => vm.client_uuid === lState.slidingPopup.params?.clientUUID
      ).length === 0
        ? lState.slidingPopup.params?.clientUUID
        : "",
    schedule_uuid: "",
    recovery_point: 0,
    memory: calculateAvailableRam() >= 2147483648 ? 2147483648 : 1073741824,
    processors: 2,
    network: {
      source: "default",
      controller: "e1000"
    },
    video: "qxl",
    boot_params: {
      enable: "no",
      timeout: 30000
    },
    storage_params: {
      target_bus: "sata"
    }
  });

  function calculateAvailableRam() {
    // const totalRam = 17179869184
    let ramFree = 17179869184;
    props.vmsList.forEach(vm => {
      ramFree = ramFree - vm.memory;
    });
    return ramFree;
  }

  function handleDropDown(option) {
    const temp = { ...dropDowns };
    temp[option] = !temp[option];
    setDropDowns(temp);
  }

  useEffect(() => {
    if (
      lState.slidingPopup.params?.clientUUID &&
      props.vmsList.filter(
        vm => vm.client_uuid === lState.slidingPopup.params?.clientUUID
      ).length === 0
    ) {
      props.fetchVIRTRecoveryPointsStart(
        lState.slidingPopup.params?.clientUUID,
        {
          type: 6, //VIRTUALIZATION
          onMount: true,
          serverIPAddress: ""
        }
      );
    }
  }, [lState.slidingPopup.params, props.vmsList]);

  useEffect(() => {
    if (
      vmDetails.vm_name === "" ||
      vmDetails.schedule_uuid === "" ||
      vmDetails.memory > availableRam
    ) {
      setBuildVMButton(false);
    } else {
      setBuildVMButton(true);
    }
  }, [vmDetails]);

  useEffect(() => {
    setOriginalMachinesList(
      Object.values(props.clients)
        .filter(val => val.isConfigured && val.lastBackupTime > 0)
        .sort((a, b) => a.name.localeCompare(b.name))
    );
    setSearchMachinesList(
      Object.values(props.clients)
        .filter(val => val.isConfigured && val.lastBackupTime > 0)
        .sort((a, b) => a.name.localeCompare(b.name))
    );
  }, [props.clients]);

  useEffect(() => {
    if (props.vmSliderConfig.closeSlider) {
      lMethods.closeSlidingPopup();
      setTimeout(() => {
        props.resetSliderConfigs();
      }, 1500);
    }
  }, [props.vmSliderConfig]);

  function handleMachineSearchList(input) {
    setSearchMachinesList(
      originalMachinesList.filter(val =>
        val.name.toLowerCase().includes(input.toLowerCase())
      )
    );
  }

  useEffect(() => {
    if (
      vmDetails.client_uuid &&
      !props.virtRecoveryPoints.loading &&
      props.virtRecoveryPoints.clients[vmDetails.client_uuid]?.recoveryPoints &&
      props.virtRecoveryPoints.clients[vmDetails.client_uuid]?.recoveryPoints &&
      props.virtRecoveryPoints.clients[vmDetails.client_uuid]?.recoveryPoints
        .length > 0
    ) {
      setVMDetails({
        ...vmDetails,
        schedule_uuid:
          props.virtRecoveryPoints.clients[vmDetails.client_uuid]
            ?.recoveryPoints[0].scheduleUUID,
        recovery_point:
          props.virtRecoveryPoints.clients[vmDetails.client_uuid]
            ?.recoveryPoints[0].recoveryPoint
      });
    }
  }, [props.virtRecoveryPoints.clients, vmDetails.client_uuid]);

  return (
    <React.Fragment>
      {props.vmSliderConfig.loading ? (
        <Loader />
      ) : (
        <div className="slider_summary">
          <div className="slider_content_body">
            <div className="local_virtualization_slider">
              <div className="slider_wrap">
                <div className="computer_section">
                  <div
                    className="mirror_loader flex_center"
                    style={{ display: "none" }}
                  >
                    {" "}
                    <img
                      src="images/mirror_loader.gif"
                      alt="Mirror_Loader"
                    />{" "}
                    <span className="flex_center">Processing</span>{" "}
                  </div>
                  <div className="wrapper_box">
                    <div className="message_box">
                      <div
                        className="alert alert-danger alert-dismissible custom-alert buildError"
                        style={{ display: "none" }}
                      >
                        {" "}
                        <a
                          href="#"
                          className="close"
                          data-dismiss="alert"
                          aria-label="close"
                          title="close"
                        >
                          ×
                        </a>
                        <div className="align-center">
                          {" "}
                          <i className="icon"></i>
                          <div className="txt">This is a Error message.</div>
                        </div>
                      </div>

                      <div
                        className="alert alert-success alert-dismissible  custom-alert buildSuccess"
                        style={{ display: "none" }}
                      >
                        {" "}
                        <a
                          href="#"
                          className="close"
                          data-dismiss="alert"
                          aria-label="close"
                          title="close"
                        >
                          ×
                        </a>
                        <div className="align-center">
                          <div className="txt_2">
                            This is a success message.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons choose_system"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>Choose a system :</label>
                          <ClickAwayListener
                            onClickAway={() => {
                              setSearchMachinesList(originalMachinesList);
                              setSearchInputField("");
                              setDropDowns({
                                ...dropDowns,
                                machinesList: false
                              });
                            }}
                          >
                            <div className="select_box main_select">
                              <select className="search_list"></select>
                              <div
                                className={[
                                  "dropdown_select wide search_list",
                                  dropDowns.machinesList ? "open" : ""
                                ].join(" ")}
                                onClick={() => handleDropDown("machinesList")}
                                tabIndex={0}
                              >
                                <span className="current">
                                  {vmDetails.vm_name === ""
                                    ? "None"
                                    : decodeHandler(vmDetails.vm_name)}
                                </span>
                                <div className="list">
                                  {/* TODO: Implement search for machines */}
                                  <div className="dd-search">
                                    <input
                                      onClick={e => e.stopPropagation()}
                                      id="txtSearchValue"
                                      placeholder="Search "
                                      autoComplete="off"
                                      className="dd-searchbox search_field"
                                      type="text"
                                      defaultValue={""}
                                      value={searchInputField}
                                      onChange={e => {
                                        handleMachineSearchList(e.target.value);
                                        setSearchInputField(e.target.value);
                                      }}
                                    />
                                    <span
                                      className="drp_cls_icn"
                                      onClick={e => {
                                        e.stopPropagation();
                                        setSearchInputField("");
                                        setSearchMachinesList(
                                          originalMachinesList
                                        );
                                      }}
                                    ></span>
                                  </div>
                                  <ul>
                                    {searchMachinesList.length > 0 ? (
                                      searchMachinesList.map((val, index) => {
                                        const isDisabled = props.vmsList.some(
                                          vm =>
                                            vm.client_uuid === val.clientUUID
                                        );
                                        return (
                                          <li
                                            key={index}
                                            className={[
                                              "option ",
                                              props.vmsList.filter(
                                                vm =>
                                                  vm.client_uuid ===
                                                  val.clientUUID
                                              ).length > 0
                                                ? "disabled"
                                                : vmDetails.vm_name === val.name
                                                ? "selected"
                                                : ""
                                            ].join(" ")}
                                            data-value=""
                                            data-display-text=""
                                            onClick={e => {
                                              if (isDisabled) {
                                                e.stopPropagation();
                                              } else {
                                                setVMDetails({
                                                  ...vmDetails,
                                                  vm_name: val.name,
                                                  client_uuid: val.clientUUID,
                                                  schedule_uuid: "",
                                                  recovery_point: 0
                                                });
                                                props.fetchVIRTRecoveryPointsStart(
                                                  val.clientUUID,
                                                  {
                                                    type: 6, //VIRTUALIZATION
                                                    onMount: true,
                                                    serverIPAddress:
                                                      val.serverIPAddress
                                                  }
                                                );
                                              }
                                            }}
                                          >
                                            {decodeHandler(val.name)}
                                          </li>
                                        );
                                      })
                                    ) : (
                                      <li
                                        className="option selected"
                                        data-value="None"
                                        data-display-text=""
                                      >
                                        None
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                              <span
                                className="error-msg"
                                style={{ display: "none" }}
                              >
                                The field cannot be blank
                              </span>{" "}
                            </div>
                          </ClickAwayListener>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons recovery_point"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>Choose a recovery point :</label>
                          <ClickAwayListener
                            onClickAway={() =>
                              setDropDowns({
                                ...dropDowns,
                                recoveryPoints: false
                              })
                            }
                          >
                            <div className="select_box main_select">
                              <select className="search_list">
                                <option selected disabled>
                                  None
                                </option>
                              </select>
                              <div
                                className={[
                                  "dropdown_select wide search_list",
                                  vmDetails.vm_name !== "" &&
                                  dropDowns.recoveryPoints
                                    ? "open"
                                    : vmDetails.vm_name === ""
                                    ? "transparent_layer"
                                    : ""
                                ].join(" ")}
                                tabIndex={0}
                                onClick={() => {
                                  if (vmDetails.vm_name !== "")
                                    handleDropDown("recoveryPoints");
                                }}
                              >
                                <span className="current">
                                  {vmDetails.schedule_uuid === ""
                                    ? "None"
                                    : props.virtRecoveryPoints.clients[
                                        vmDetails.client_uuid
                                      ]?.recoveryPoints.filter(
                                        val =>
                                          val.scheduleUUID ===
                                          vmDetails.schedule_uuid
                                      ).length > 0
                                    ? epocToDate(
                                        props.virtRecoveryPoints.clients[
                                          vmDetails.client_uuid
                                        ]?.recoveryPoints.filter(
                                          val =>
                                            val.scheduleUUID ===
                                            vmDetails.schedule_uuid
                                        )[0].recoveryPoint,
                                        "MMM d yyyy, hh:mm:ss"
                                      )
                                    : "None"}
                                </span>
                                <div className="list">
                                  <ul>
                                    {props.virtRecoveryPoints.loading ? (
                                      <li
                                        class="option selected drop_loader"
                                        data-value="None"
                                        data-display-text=""
                                      >
                                        <p class="drop_loading_image"></p>
                                      </li>
                                    ) : props.virtRecoveryPoints.clients[
                                        vmDetails.client_uuid
                                      ]?.recoveryPoints &&
                                      props.virtRecoveryPoints.clients[
                                        vmDetails.client_uuid
                                      ]?.recoveryPoints.length > 0 ? (
                                      props.virtRecoveryPoints.clients[
                                        vmDetails.client_uuid
                                      ]?.recoveryPoints.map((val, i) => (
                                        <li
                                          key={i}
                                          className={
                                            vmDetails.schedule_uuid ===
                                            val.scheduleUUID
                                              ? "option selected"
                                              : "option"
                                          }
                                          onClick={() =>
                                            setVMDetails({
                                              ...vmDetails,
                                              schedule_uuid: val.scheduleUUID,
                                              recovery_point: val.recoveryPoint
                                            })
                                          }
                                        >
                                          {epocToDate(
                                            val.recoveryPoint,
                                            "MMM d yyyy, hh:mm:ss"
                                          )}
                                        </li>
                                      ))
                                    ) : (
                                      <li class="option selected" disabled>
                                        None
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                              <span
                                className="error-msg"
                                style={{ display: "none" }}
                              >
                                The field cannot be blank
                              </span>{" "}
                            </div>
                          </ClickAwayListener>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons processor"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>Processors :</label>
                          <div className="select_box main_select">
                            <select
                              value={vmDetails.processors}
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  processors: e.target.value
                                })
                              }
                            >
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                            </select>
                            <span
                              className="error-msg"
                              style={{ display: "none" }}
                            >
                              The field cannot be blank
                            </span>{" "}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons ram"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>RAM :</label>
                          <div class="select_box main_select">
                            <select
                              name="ram"
                              value={vmDetails.memory}
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  memory: +e.target.value
                                })
                              }
                            >
                              {ramMemoryList.map(
                                ram =>
                                  availableRam >= ram * 1024 * 1024 * 1024 && (
                                    <option
                                      key={ram}
                                      value={ram * 1024 * 1024 * 1024}
                                    >
                                      {ram} GB
                                    </option>
                                  )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons network_source"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Network Source :
                            <Tooltip
                              title="Choose how the virtual instance should be attached to the network through IDrive Mirror"
                              placement="top"
                            >
                              <NetworkSource />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={
                                vmDetails.network
                                  ? vmDetails.network.source
                                  : "disconnected"
                              }
                              onChange={e => {
                                if (e.target.value === "disconnected") {
                                  setVMDetails({
                                    ...vmDetails,
                                    network: null
                                  });
                                } else {
                                  setVMDetails({
                                    ...vmDetails,
                                    network: {
                                      ...vmDetails.network,
                                      source: e.target.value,
                                      controller: "e1000"
                                    }
                                  });
                                }
                              }}
                            >
                              <option value="disconnected">Disconnected</option>
                              <option value="default">NAT (Firewalled)</option>
                              {/* <option value="">
                                                        Bridged to 'eno1'(IP:
                                                        192.168.3.51)
                                                    </option> */}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons network_model"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Network Model :
                            <Tooltip
                              title="Choose an appropriate virtual network adapter model"
                              placement="top"
                            >
                              <NetworkModel />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={
                                vmDetails.network
                                  ? vmDetails.network.controller
                                  : "e1000"
                              }
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  network: {
                                    ...vmDetails.network,
                                    controller: e.target.value
                                  }
                                })
                              }
                              disabled={
                                vmDetails.network === null ||
                                vmDetails.network.source === "disconnected"
                              }
                            >
                              {vmDetails.network === null ||
                              vmDetails.network.source === "disconnected" ? (
                                <option selected="true">None</option>
                              ) : (
                                <React.Fragment>
                                  <option value="e1000">
                                    Intel 82545EM Gigabit Ethernet
                                  </option>
                                  {/* <option value="rtl8139">
                                    Realtek RTL8139 PCI Fast Ethernet
                                  </option>
                                  <option value="virtio">
                                    Paravirtualized Network (VirtIO)
                                  </option> */}
                                </React.Fragment>
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons storage_controller"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Storage Controller :
                            <Tooltip
                              title="Choose an appropriate storage controller, which closely matches with the storage controller used on the machine"
                              placement="top"
                            >
                              <StorageController />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={vmDetails.storage_params.target_bus}
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  storage_params: {
                                    target_bus: e.target.value
                                  }
                                })
                              }
                            >
                              <option value="sata">SATA</option>
                              {/* <option value="scsi">
                                                        LsiLogicSAS
                                                    </option>
                                                    <option value="virtio">
                                                        VirtIO
                                                    </option> */}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons graphics"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Graphics :
                            <Tooltip
                              title="QXL is recommended for newer operating systems. Select VGA for older operating systems."
                              placement="top"
                            >
                              <VideoGraphics />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={vmDetails.video}
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  video: e.target.value
                                })
                              }
                            >
                              <option value="qxl">QXL</option>
                              <option value="vga">VGA</option>
                              {/* <option value="cirrus">CIRRUS</option> */}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box row_box_boot_menu">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons boot_menu"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Enable boot menu
                            <Tooltip
                              title="Enable BIOS boot menu during VM startup"
                              placement="top"
                            >
                              <BootMenu />
                            </Tooltip>
                          </label>
                          <div className="check_box enable_boot_menu">
                            <div class=" boot__btn">
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  onClick={e =>
                                    setVMDetails({
                                      ...vmDetails,
                                      boot_params: {
                                        ...vmDetails.boot_params,
                                        enable:
                                          vmDetails.boot_params.enable === "no"
                                            ? "yes"
                                            : "no",
                                        timeout:
                                          vmDetails.boot_params.timeout < 3
                                            ? 3
                                            : vmDetails.boot_params.timeout
                                      }
                                    })
                                  }
                                />
                                <span
                                  class={[
                                    "slider round ",
                                    vmDetails.boot_params.enable === "yes"
                                      ? "enabledOn"
                                      : "enabledOff"
                                  ].join(" ")}
                                ></span>
                              </label>
                            </div>
                            <div className="text_box ">
                              <input
                                type="number"
                                min="3"
                                max="60"
                                maxLength="2"
                                className="input_text w_80"
                                value={vmDetails.boot_params.timeout / 1000}
                                disabled={vmDetails.boot_params.enable === "no"}
                                onKeyDown={e => {
                                  // Prevent unwanted characters: decimals, negative signs, and the "e" key (scientific notation)
                                  if (
                                    e.key === "." ||
                                    e.key === "-" ||
                                    e.key.toLowerCase() === "e"
                                  ) {
                                    e.preventDefault(); // Prevent the default input behavior
                                  }
                                }}
                                onChange={e => {
                                  // const value = e.target.value.replace(/\D/g, "");
                                  if (
                                    +e.target.value <= 60 &&
                                    +e.target.value >= 3
                                  ) {
                                    setVMDetails({
                                      ...vmDetails,
                                      boot_params: {
                                        ...vmDetails.boot_params,
                                        timeout: +e.target.value * 1000
                                      }
                                    });
                                  }
                                }}
                              />
                              <span
                                className="img_info_icon"
                                tooltipwidth="190"
                              ></span>
                              <span className="txt">Timeout in seconds</span>
                            </div>
                          </div>
                        </div>
                        {vmDetails.boot_params.enable === "yes" && (
                          <p className="row_message">
                            <strong>Note:</strong> For better virtual machine
                            performance, disable the boot menu.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slider_content_footer">
                <div className="slider_summary_btns">
                  <div className="slider_summary_btns__inner">
                    <div className="backup_image_btns ">
                      <div
                        className={[
                          "slider_btn full_img_backup_btn btn_primary btn_create_machine",
                          enableBuildVMButton ? "" : "btn_disable"
                        ].join(" ")}
                        onClick={() => {
                          if (enableBuildVMButton) {
                            props.createVMTaskStart(vmDetails, false);
                          }
                        }}
                      >
                        Build Virtual Instance
                      </div>
                    </div>
                    {/* <div className="loader" style={{ display: "none" }}>
                                    <div className="loader__image">
                                        <div className="loader__progress progress">
                                            <div className="progress__bar"></div>
                                            <div className="progress__value">0</div>
                                        </div>
                                    </div>
                                </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

AddVirtualMachine.propTypes = forbidExtraProps(
  {
    virtRecoveryPoints: PropTypes.arrayOf(PropTypes.object),
    clients: PropTypes.object,
    vmSliderConfig: PropTypes.object,
    vmsList: PropTypes.arrayOf(PropTypes.object)
  },
  [
    "dispatch",
    "fetchVIRTRecoveryPointsStart",
    "createVMTaskStart",
    "resetSliderConfigs"
  ]
);

function mapStateToProps(state) {
  return {
    clients: state.dashboard.clients.list,
    vmsList: state.virtualization.vmsList,
    vmSliderConfig: state.virtualization.sliderConfig,
    virtRecoveryPoints: state.virtualization.virtRecoveryPoints
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchVIRTRecoveryPointsStart,
      createVMTaskStart,
      resetSliderConfigs
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AddVirtualMachine);
